import { faUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Skeleton, TextField, ThemeProvider } from '@mui/material';
import Button from '@mui/material/Button';
import { useApi } from '../Store/ApiContext';
import joi from 'joi';
import { constantsErrorMessage, editSuccessMessage, validationErrorMessage } from '../../constants/global';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { enqueueSnackbar } from 'notistack';
import { MuiTelInput } from 'mui-tel-input';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { customAlphabet } from 'nanoid'

export default function InvoiceSettings({ theme, decodeToken }) {

    const { showInvalidFeedback, getData, responseApi, getSlug } = useApi();

    const location = useLocation()
    const { t, i18n } = useTranslation()

    const [uploadedLogoUrl, setUploadedLogoUrl] = useState("");
    const [type, setType] = useState('');
    const [file, setFile] = useState();
    const [organizationData, setOrganizationData] = useState({
        footerInvoice: '',
        orgNameInvoice: '',
    });


    // function handleChangeImage(e) {
    //     setFile(URL.createObjectURL(e.target.files[0]));
    // }

    // function handleImageDelete(imageSrc) {
    //     const imageName = imageSrc.split("%2F").reverse()[0].split("?")[0];
    //     // Create a reference to the file to delete
    //     const storage = getStorage();
    //     const slug = getSlug();
    //     const imageRef = ref(storage, `orgLogos/${slug}/${imageName}`);

    //     // Delete the file
    //     deleteObject(imageRef).then(() => {
    //         // File deleted successfully
    //         console.log("File deleted successfully");
    //     }).catch((error) => {
    //         // Uh-oh, an error occurred!
    //         console.log("an error occurred!", error);
    //     });
    //     const myOrgData = { ...organizationData };
    //     myOrgData.orgLogo = "";
    //     console.log(myOrgData);
    //     setOrganizationData(myOrgData)
    // }

    // const handleImageUpload = async (images) => {
    //     try {
    //         if (organizationData.orgLogo) {
    //             handleImageDelete(organizationData.orgLogo);
    //         }
    //         const file = images.target.files[0];
    //         console.log(file);

    //         const slug = getSlug();
    //         const storage = getStorage();
    //         const storageRef = ref(storage, `orgLogos/${slug}`); //orgLogos is the folder we will upload org logo to it

    //         if (file.size <= 5242880) {
    //             const image = file;
    //             const nanoid = customAlphabet('1234567890abcdefghtklmnoqzx', 16);
    //             const imageName = nanoid();
    //             const imageRef = ref(storageRef, imageName);
    //             await uploadBytes(imageRef, image);
    //             const downloadURL = await getDownloadURL(imageRef);
    //             // Store the downloadURL in your database
    //             console.log('Download URL:', downloadURL.split('?')[0] + "?alt=media");
    //             let uploadedMediaUrl = downloadURL.split('?')[0] + "?alt=media";
    //             handleChange('', "orgLogo", uploadedMediaUrl);
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    function handleChange(e, id, newValue) {
        // deep copy
        let myData;
        myData = { ...organizationData };
        // update data
        myData[e.target.id] = e.target.value;
        // set new data
        console.log(myData);
        setOrganizationData(myData);
    }

    // function handleChangeFooterInvoice(e) {
    //     setOrganizationData({ footerInvoice: e.target.value });
    // }

    function clearInputsDataRow() {
        setOrganizationData({
            footerInvoice: '',
            orgNameInvoice: '',
        })
    }

    function validationReqData(newData) {
        const schema = joi.object().required().keys({
            footerInvoice: joi.string().max(1000).allow(''),
            orgNameInvoice: joi.string().max(100).allow(''),
        });
        return schema.validate(newData, { abortEarly: false })
    }

    async function editOrganizationData() {
        const newData = {
            footerInvoice: organizationData.footerInvoice,
            orgNameInvoice: organizationData.orgNameInvoice,
        }

        const decoded = decodeToken();
        const validationData = validationReqData(newData);
        if (validationData.error) {
            enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
            showInvalidFeedback(validationData.error.details);
            return 0;
        } else {
            const res = await responseApi('put', newData, "organization", decoded.orgId);
            if (res.message === "success") {
                enqueueSnackbar(<>{t(editSuccessMessage)}</>, { variant: "success" });
                getData(setOrganizationData, "organization");
                clearInputsDataRow();
            } else if (res.message === "validation error") {
                enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
                showInvalidFeedback(res.validationError[0].details);
            } else {
                enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(res.message)}</>, { variant: "error" });
            }
        }
        showInvalidFeedback([]);
    }

    useEffect(() => {
        // add title page
        document.title = t("invoiceSettings");
        // get data for table
        getData(setOrganizationData, "organization");
    }, []);

    return (
        <>
            <section className='bg-babyblue-50 big-card settings-big-card container-fluid'>
                <div className="header-card d-flex justify-content-between align-items-center">
                    <div className="header-title">
                        <h2 className='fw-bolder'>{t("invoiceSettings")}</h2>
                    </div>
                </div>
                <ThemeProvider theme={theme}>
                    <div className='info-cards-settings mx-3'>
                        <div className='d-flex flex-column justify-content-between align-items-center px-4'>
                            <div className='inputs-info-settings w-100'>
                                <ul className='mx-sm-0 mx-auto'>
                                    <li className='my-3'>
                                        <TextField
                                            id='orgNameInvoice'
                                            className='textfield-input'
                                            value={organizationData.orgNameInvoice}
                                            label={t("orgNameInvoice")}
                                            onChange={handleChange}
                                            variant="standard"
                                            type="text"
                                        />
                                        <div className="text-helper-invalid d-none">{t("pleaseEnterTheOrgNameInvoiceText")}</div>
                                    </li>
                                    <li className='my-3'>
                                        <TextField
                                            id='footerInvoice'
                                            className='textfield-input'
                                            value={organizationData.footerInvoice}
                                            multiline
                                            rows={4}
                                            inputProps={{ maxLength: 1000 }}
                                            label={t("footerInvoice")}
                                            onChange={handleChange}
                                            variant="standard"
                                            type="text"
                                        />
                                        <div className='text-start text-danger'>{1000 - (organizationData.footerInvoice?.length || 0)}</div>
                                        <div className="text-helper-invalid d-none">{t("pleaseEnterTheInvoiceFooterText")}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </ThemeProvider>
                <div className='text-start mt-2'>
                    <Button variant="contained" className='btn-myPrimary  m-3 my-5' onClick={editOrganizationData}>{t("Save Changes")}</Button>
                </div>
            </section>
        </>
    )
}